import React from 'react';
import ClientItem from '../../../Domain/ClientItem';
import ClientService from '../../../Services/clientService';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';

export default class AddParentWindowDescription extends React.Component {
  static titleForCreate = 'Link To Parent';
  static titleForEdit = 'Link To Parent';
  static itemType = AddParentWindowDescription.getItemType;
  static serviceFunction = (edited) => ClientService.AddParent(edited.ClientId, edited.ParentId);

  static getItemType() {
    // eslint-disable-next-line global-require
    return require('../../../Domain/ClientItem').default;
  }
  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'ParentId',
          label: 'Parent',
          className: 'col-12',
          type: InputTypesEnum.ClientSelect,
          validityChecker: ValidityHelper.forClientMatchCheck,
        },
      ],
    },
  ];
}
